<div class="warning-modal-content">

  <h4>{{ 'portal.warning.title' | translate }}</h4>
  <p>{{ 'portal.warning.warning' | translate }}</p>

  <button class="submit" mat-dialog-close>
    {{ 'portal.warning.accept' | translate }}
  </button>

</div>
